import { orgRegulatingFiltersDiscovery } from '../api/org_regulating_filters'
import type { Resolvers } from '../generated/server/resolvers'

const OrgRegulatingFilter: Resolvers = {
  Query: {
    orgRegulatingFiltersDiscovery,
  },
}

export default OrgRegulatingFilter
